export function stripAtPrefix(value: string): string {
  return (value || '').replace(/^@+/, '').trim();
}
